import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { usePayment } from '../context/PaymentContext';
import LoadingSpinner from '../components/common/LoadingSpinner';
import './PaymentReturn.css';

const PaymentReturn: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { verifyPayment } = usePayment();
  const [status, setStatus] = useState<'processing' | 'success' | 'failed'>('processing');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const handlePaymentReturn = async () => {
      try {
        // Get payment parameters from URL
        const orderId = searchParams.get('razorpay_order_id');
        const paymentId = searchParams.get('razorpay_payment_id');
        const signature = searchParams.get('razorpay_signature');

        if (!orderId || !paymentId || !signature) {
          setStatus('failed');
          setMessage('Payment verification failed: Missing required parameters');
          return;
        }

        // Verify payment
        const verified = await verifyPayment(orderId, paymentId, signature);
        
        if (verified) {
          setStatus('success');
          setMessage('Payment successful! Your subscription has been activated.');
          
          // Redirect to home after 3 seconds
          setTimeout(() => {
            navigate('/horoscope');
          }, 3000);
        } else {
          setStatus('failed');
          setMessage('Payment verification failed. Please contact support.');
        }
      } catch (error) {
        console.error('Payment return error:', error);
        setStatus('failed');
        setMessage('An error occurred during payment verification.');
      }
    };

    handlePaymentReturn();
  }, [searchParams, navigate, verifyPayment]);

  const handleGoHome = () => {
    navigate('/horoscope');
  };

  if (status === 'processing') {
    return (
      <div className="payment-return-container">
        <div className="payment-return-card">
          <div className="processing-state">
            <div className="spinner"></div>
            <h2>Verifying Payment...</h2>
            <p>Please wait while we verify your payment</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="payment-return-container">
      <div className="payment-return-card">
        {status === 'success' ? (
          <div className="success-state">
            <div className="success-icon">✅</div>
            <h2>Payment Successful!</h2>
            <p>{message}</p>
            <p>Redirecting to your dashboard...</p>
            <button onClick={handleGoHome} className="home-button">
              Go to Dashboard
            </button>
          </div>
        ) : (
          <div className="failed-state">
            <div className="failed-icon">❌</div>
            <h2>Payment Failed</h2>
            <p>{message}</p>
            <div className="failed-actions">
              <button onClick={handleGoHome} className="home-button">
                Go to Home
              </button>
              <button onClick={() => navigate('/plans')} className="plans-button">
                Try Again
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PaymentReturn;
